import { useState } from 'react';
import { navLinks } from '../data';

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between px-4 md:px-6 py-3">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 text-background-50">
            <span className="font-heading text-base font-extrabold leading-none">52</span>
          </span>
          <span className="flex flex-col">
            <h1 className="font-heading text-lg md:text-xl font-extrabold leading-none tracking-tight text-foreground-950">
              52爆料
            </h1>
            <span className="mt-1 text-[10px] md:text-[11px] leading-none text-foreground-500">素材 · 证据 · 细节 · 线索</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 text-sm font-medium whitespace-nowrap text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#lead"
            className="hidden md:inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-700"
          >
            <i className="ri-quill-pen-line w-4 h-4 flex items-center justify-center" />
            投稿线索
          </a>
          <button
            type="button"
            aria-label="打开导航"
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 lg:hidden"
            onClick={() => setOpen((v) => !v)}
          >
            <i className={`${open ? 'ri-close-line' : 'ri-menu-line'} w-5 h-5 flex items-center justify-center`} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto flex max-w-7xl flex-col px-4 py-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#lead"
              onClick={() => setOpen(false)}
              className="mt-1 mb-2 inline-flex items-center justify-center gap-2 rounded-md bg-primary-600 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-quill-pen-line w-4 h-4 flex items-center justify-center" />
              投稿线索
            </a>
          </div>
        </div>
      )}
    </header>
  );
}